export const archiveKinds = [
  {
    slug: 'link',
    name: 'Link'
  },
  {
    slug: 'archive',
    name: 'Arquivo'
  },
  {
    slug: 'image',
    name: 'Imagem'
  },
  {
    slug: 'embedded',
    name: 'Incorporado'
  },
  {
    slug: 'video_url',
    name: 'Vídeo URL'
  },
  {
    slug: 'text',
    name: 'Texto'
  }
]

export const getArchiveKind = (slug: string) => {
  return archiveKinds.find(kind => kind.slug === slug)
}
